/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import FormValidation from '../../atoms/formEnums/formValidation';
import InputText from '../../atoms/inputText/inputText';
import InputTag from '../../atoms/inputTag/inputTag';
import Label from '../../atoms/label/label';
import { IconType } from '../../atoms/icon/icon';
import { ButtonTheme } from '../../atoms/button/button';
import './formArray.scss';
import LoadFromCatalogButton from '../../molecules/loadFromCatalogButton/loadFromCatalogButton';
import { unset } from 'lodash';
import { randomNumberInRange } from '../../../utils/canvasUtils';


/**
 * Form Input Text is a basic HTML input field, label, error text and HelpButton.
 * It is designed to send the input value to a parent component, such as organisms Form,
 * and to shows the validation state of the field provided by the parent component.
 */
const FormArray = (props) => {
  const {
    id,
    name,
    fields,
    validation,
    errorText,
    label,
    placeholder,
    helpText,
    value,
    onChange,
    configFile,
    defaultValue,
    disabled,
    hidden,
  } = props;

  const childRef = useRef();

  const [valueState, setValueState] = useState(value !== '' ? value : defaultValue);


  const handleOnCloseLoadFromCatalog = (data) => {
    if (data !== undefined && data[configFile.mainAttribute] !== undefined) {
      childRef.current.updateValue(data[configFile.mainAttribute]);
      onChange({ target: { value: data[configFile.mainAttribute] } });
    }
  };
  useEffect(() => {
    // if (value !== valueState) {
    //   setValueState(value);
    //   childRef.current.updateValue(value);
    // }
  }, [value]);

  return (
    <div className={`form-group row text-${validation} ${(hidden?"form-input-text__hidden":"")}`}>
      { label !== ''
        && (
          <Label helpText={helpText}>{label}</Label>
        )}
      <div className="col-sm-8">
        {value && value.map((el,index)=>{ 
          return (<div className="form-array_el" key={index}>
            {fields.map((field)=>{
              return (<div key={field+randomNumberInRange(1,100)} className="form-array_block">
                  <div className="form-array_field-title">{field}: </div>
                  <div className="form-control border-pending form-array_field-value">{el[field]}</div>
                </div>);
            })}
          </div>);
        })} 
        { (validation === FormValidation.ERROR || validation === FormValidation.WARNING)
          && (
            <small className="form-text">{errorText}</small>
          )}
      </div>
    </div>
  );
};

FormArray.propTypes = {
  /**
   * id of input field
   */
  id: PropTypes.string,
  /**
   * Name of input field
   */
  name: PropTypes.string.isRequired,
  
  /**
   * Defined text errors
   */
  errorText: PropTypes.string,
  /**
   * Name of input attribute
   */
  label: PropTypes.string,
  /**
   * Placeholder inside the HTML input
   */
  placeholder: PropTypes.string,
  /**
   * Input help text
   */
  helpText: PropTypes.string,
  /**
   * Initial input value
   */
  value: PropTypes.oneOfType([PropTypes.array]),
  /**
   * Function to bind onChange HTML functionality
   */
  onChange: PropTypes.func,
  /**
   * Confinguration file to create a table
   */
  configFile: PropTypes.shape({}),
  /**
   * Default value
   */
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

};

FormArray.defaultProps = {
  id: '',
  validation: FormValidation.PENDING,
  errorText: '',
  label: '',
  placeholder: '',
  helpText: '',
  value: '',
  onChange: () => {},
  configFile: undefined,
  defaultValue: '',
};

export default FormArray;
